module.exports = __webpack_public_path__ + "static/img/about1.7960f90.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/about1.png
// module id = O5iT
// module chunks = 1